module.exports = __webpack_public_path__ + "static/events-7a3231bbb67c102f475ed7bf8c717368.png";